import { motion } from 'framer-motion'
import { useReducedMotion } from '@/lib/useReducedMotion'
import { useInView } from 'react-intersection-observer'

type Direction = 'up' | 'down' | 'left' | 'right'

interface ScrollRevealProps {
  children: React.ReactNode
  delay?: number
  direction?: Direction
  duration?: number
  threshold?: number
  className?: string
}

const directionMap: Record<Direction, { x?: number; y?: number }> = {
  up: { y: 16 },
  down: { y: -16 },
  left: { x: 16 },
  right: { x: -16 },
}

export function ScrollReveal({ 
  children, 
  delay = 0, 
  direction = 'up',
  duration = 0.4,
  threshold = 0,
  className = ''
}: ScrollRevealProps) {
  const reducedMotion = useReducedMotion()
  const [ref, inView] = useInView({ 
    threshold, 
    triggerOnce: true 
  })

  return (
    <motion.div
      ref={ref}
      className={className}
      initial={reducedMotion ? false : { opacity: 0, ...directionMap[direction] }}
      animate={inView || reducedMotion ? { opacity: 1, x: 0, y: 0 } : {}}
      transition={{ 
        delay: reducedMotion ? 0 : delay,
        duration: reducedMotion ? 0 : duration,
        ease: [0.22, 1, 0.36, 1]
      }}
    >
      {children}
    </motion.div>
  )
}
